import React from 'react';
import type { FC } from 'react';

import type { TErrorDesktop } from '../model';
import { ErrorIcon } from '../../../components/error-icon';
import { defaultErrorOverlimitSettings } from '../config/default-values';

export const ErrorOverlimitDesktop: FC<TErrorDesktop> = ({
    Aligner,
    Text,
    subtitle = defaultErrorOverlimitSettings.subtitle,
    title = defaultErrorOverlimitSettings.title,
}) => {
    return (
        <Aligner>
            <ErrorIcon />
            <Text styler={{ marginBottom: 32, marginTop: 24 }} tag="h2" view="small">
                {title}
            </Text>
            <Text styler={{ marginTop: 0, marginBottom: 0 }} view="primary-medium">
                {subtitle}
            </Text>
        </Aligner>
    );
};
